var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-container",style:(_vm.styles[_vm.data])},[_vm._v(" "+_vm._s(_vm.situacaoDesc[_vm.data])+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }